export default __webpack_public_path__ + "static/media/ip-address-icon.b86246e0.svg";